import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "not-found" }
const _hoisted_2 = { class: "icon-container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "title-404" }, "404", -1)
const _hoisted_4 = { class: "desc" }

import { CircleCloseFilled } from '@element-plus/icons-vue'
import useI18nTl from '@/hooks/useI18nTl'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { tl } = useI18nTl('Base')

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_icon, { size: 60 }, {
        default: _withCtx(() => [
          _createVNode(_unref(CircleCloseFilled))
        ]),
        _: 1
      }),
      _hoisted_3,
      _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(tl)('notFound')), 1)
    ])
  ]))
}
}

})